import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    DOWNLOAD_FILTER: 'Tipo de certificação',
    DOWNLOAD_FILTER_ALL: 'Todos ({{count}})',
    DOWNLOAD_FILTER_DIPLOMA: 'Certificados ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_COURSES: 'Certificados cursos ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_TRACKS: 'Certificados trilhas ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_LIVE_SESSIONS:
      'Certificados ao vivo ({{count}})',
    DOWNLOAD_FILTER_PROOF: 'Constância de cursos ({{count}})',
    DOWNLOAD_DIPLOMA: 'Certificado',
    DOWNLOAD_PROOF: 'PROVA',
    DOWNLOAD_DESCRIPTION_GENERAL:
      'No total, obteve {{diplomasCount}} certificados e {{certificateCount}} certificados de participação',
    TYPE_CERTIFICATE: 'Tipo de certificado',
  },
};
